// @flow
import { HttpError } from 'lib/errors';

type Props = {
  requestStatus: ?RequestStatus,
  match: HttpError => boolean,
  render: HttpError => React$Element<any>,
  children?: any,
};

const HandleRequestError = (props: Props) => {
  const { children, requestStatus, match, render } = props;

  return requestStatus instanceof HttpError && match(requestStatus)
    ? render(requestStatus)
    : children;
};

export default HandleRequestError;



// WEBPACK FOOTER //
// ./src/containers/HandleRequestError.js